import { CSSProperties } from "react"

export const StyleProps1: CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid #304aca"
}
export const StylePropsError: CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid red"
}



export const StyleProps3 : CSSProperties = {
    color: "#304aca",
    textAlign: "center"
}


export const StyleProps2 : CSSProperties = {
    marginLeft:"10px"
}